import {
  IMessagingSettings,
  IMessagingSettingsSave,
} from '@dataTypes/messaging-settings.type'
import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import { toApiError } from './errors/api-error'

const CLINIC_BUSINESS_API = getEnv('REACT_APP_BUSINESS_LAYER_CLINIC')

interface ApiEnvelope<T> {
  statusCode: number
  message: string
  data: T
}

type MessagingSettingsResponse = ApiEnvelope<{
  messaging_settings?: IMessagingSettings
}>
type AllMessagingSettingsByClinicResponse = ApiEnvelope<{
  messaging_settings?: IMessagingSettings[]
}>

export const fetchMessagingSettingsApi = async (
  clinicId: string,
): Promise<MessagingSettingsResponse> => {
  try {
    const response = await axios.get<MessagingSettingsResponse>(
      `${CLINIC_BUSINESS_API}/api/v1/clinic/messaging-settings/${clinicId}`,
    )
    return response.data
  } catch (e: unknown) {
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const fetchMessagingSettingsByClinicApi = async (
  clinicId: string,
): Promise<AllMessagingSettingsByClinicResponse> => {
  try {
    const response = await axios.get<AllMessagingSettingsByClinicResponse>(
      `${CLINIC_BUSINESS_API}/api/v1/clinic/messaging-settings/clinic/${clinicId}`,
    )
    return response.data
  } catch (e: unknown) {
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const saveMessagingSettingsApi = async (
  payload: IMessagingSettingsSave & { updated_by?: string | null },
): Promise<MessagingSettingsResponse> => {
  try {
    const response = await axios.put<MessagingSettingsResponse>(
      `${CLINIC_BUSINESS_API}/api/v1/clinic/messaging-settings`,
      payload,
    )
    return response.data
  } catch (e: unknown) {
    throw toApiError(e, 'An unknown error occurred')
  }
}
